import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import Spinner from '../../components/Spinner'
import { getStationShowMenu } from '../../actions/contentActions'
import { store } from '../../store'
import defaultStationImage from '../../assets/img/station-default.webp'
import fallbackLogo from '../../assets/img/PBSNational.webp'
import tts from '../../lib/TTS'
import {
  ComcastErrorType,
  platformTransitionStyle,
} from '../../../../shared/helpers'
import googleAnalytics4 from '../../lib/googleAnalytics.js'
import CollectionsSet from '../../components/CollectionsSet'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'
import { createPortal } from 'react-dom'

class MyStationScreen extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      spinnerVisible: true,
      scenery: '',
    }
    this.readTTS = false
    this.placeholderRef = React.createRef()
    this.carouselListRef = React.createRef()
    this.stationScreenTextToRead = `PBS ${props.shortCommonName}.
    Continue enjoying the best of PBS by supporting your local station. Donate online at:www.pbs.org/donate/${this.props.callSign}. ...`
  }

  componentDidMount() {
    this.getPageData()

    googleAnalytics4.sendPageViewEvent('My Station')

    // GOOGLE ANALYTICS
    /* window.ga('set', 'dimension1', callSign)
    window.ga('set', 'dimension2', UID)
    window.ga('set', 'dimension3', deviceModel)
    window.ga('send', 'pageview', 'My Station') */
  }

  componentWillUnmount() {
    tts.stopRead()
  }

  getPageData = () => {
    getStationShowMenu(this.props.stationId)
      .then((collectionsResponse) => {
        store.dispatch({
          type: 'UPDATE_STATION',
          payload: { showMenu: collectionsResponse },
        })

        let collections = collectionsResponse.collections
        if (collections[0]?.content?.length === 0) {
          collections = [
            {
              collection_type: 'inline',
              slug: 'my-station-empty-set',
              title: '',
              item_type: 'show',
              url: '',
              content: [
                {
                  title: '',
                  empty_set: true,
                  feed_cid: 'my-station-empty-card',
                },
              ],
            },
          ]
        }

        this.setState({
          rows: [],
          selectedRow: 0,
          collections,
          spinnerVisible: false,
        })
      })
      .catch((error) => {
        console.error(error)
        store.dispatch({
          type: 'TRIGGER_ERROR',
          payload: {
            error: {
              content: {
                error,
                errorPath: this.props.router.location.pathname,
              },
              codeBaseLocation: 'MyStationScreen - getPageData',
              errorType: ComcastErrorType.network,
            },
          },
        })

        this.props.router.navigate('/error', { replace: true })
      })
  }

  render() {
    const { scenery, white_cobranded_logo, callSign } = this.props
    const { collections, spinnerVisible } = this.state

    const bgImage = scenery ? scenery : defaultStationImage

    const logo = white_cobranded_logo ? white_cobranded_logo : fallbackLogo

    return (
      <>
        {spinnerVisible && <Spinner />}
        {!spinnerVisible &&
          collections &&
          createPortal(
            <section
              className="my-station-screen-background"
              style={{
                backgroundImage: `url(${bgImage})`,
              }}
            >
              <div className="overlay"></div>
            </section>,
            document.getElementById('full-width-background')
          )}
        {!spinnerVisible && collections && (
          <div className={`my-station-content-container`}>
            <div
              className="my-station-content-container-top"
              style={{
                transition: platformTransitionStyle('transform 500ms linear'),
              }}
            >
              <div className="local-station-info">
                <div className="logo-container">
                  <img className="logo" src={logo} alt={`${callSign} logo`} />
                </div>
                <div className="description">
                  <p className="details">
                    Continue enjoying the best of PBS by supporting your local
                    station. Donate online at:
                  </p>
                  <h2 className="link">
                    www.pbs.org/donate/
                    {callSign}
                  </h2>
                </div>
              </div>
            </div>
            <CollectionsSet
              collections={collections}
              singleRow={true}
              extraTts={this.stationScreenTextToRead}
              className="my-station__collections-set"
            />
          </div>
        )}
      </>
    )
  }
}

MyStationScreen.propTypes = {
  UID: PropTypes.string,
  callSign: PropTypes.string,
  deviceModel: PropTypes.string,
  stationId: PropTypes.string,
  scenery: PropTypes.string,
  white_cobranded_logo: PropTypes.string,
  shortCommonName: PropTypes.string,
  router: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
    navigate: PropTypes.func,
  }),
}

const mapStateToProps = (state) => {
  return {
    stationId: state.station.station_id,
    uid: state.device.UID,
    callSign: state.station.call_sign,
    shortCommonName: state.station.short_common_name,
    deviceModel: state.device.deviceModel,
    scenery: state.station.station_scenery,
    white_cobranded_logo: state.station.white_cobranded_logo,
  }
}

export default connect(mapStateToProps, null, null)(withRouter(MyStationScreen))
